export default (
  state = {
    updatedAt: null,
    slug: '',
    previous: null,
    pathname: null,
    title: '',
    backgroundImage: null,
  },
  action
) => {
  switch (action.type) {
    case 'REQUEST_PAGE':
      return {
        ...state,
        slug: action.slug,
        title: '',
        backgroundImage: null,
      }
    case 'RECEIVE_PAGE':
      return {
        ...state,
        updatedAt: Date.now(),
        slug: action.slug,
        previous: state.pathname,
        pathname: action.pathname,
        title: action.title,
        backgroundImage: action.backgroundImage,
      }
    default:
      return state
  }
}
